import { PlantLayoutAreaDrawingsThemeModeConfig } from './types';

const dark: PlantLayoutAreaDrawingsThemeModeConfig = {
  plantLayoutAreaDrawings: {
    buttonContainerBackground: '#DADBDC',
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
    arrowButtonBGColor: '#505251',
    activeButtonTextColor: 'black',
    inactiveButtonTextColor: 'white',
    activeButtonBGColor: '#99ffff',
    inactiveButtonBGColor: '#505251',
  },
};

export default dark;
